import * as ActionTypes from './actionType.js';

const reducerMap = {
    [ActionTypes.GET_FILTER_LIST_REQUEST]: (state,payload) => {
        return Object.assign({}, state, {
            fetchStatus: true,
        });
    },
    [ActionTypes.GET_FILTER_LIST_SUCCESS]: (state,payload) => {
        return Object.assign({}, state, {
            filterList:payload.grade,
            filterAssist:payload.assist_type,
            fetchStatus:false,
        });
    },
    [ActionTypes.GET_FILTER_LIST_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            error: payload,
            fetchStatus:false,
        });
    },

    //知识点树
    [ActionTypes.GET_TREEDATE_KNOW_LIST_REQUEST]: (state,payload) => {
        return Object.assign({}, state, {
            fetchStatus: true,
        });
    },
    [ActionTypes.GET_TREEDATE_KNOW_LIST_SUCCESS]: (state,payload) => {
        return Object.assign({}, state, {
            knowTree:payload,
            fetchStatus:false,
        });
    },
    [ActionTypes.GET_TREEDATE_KNOW_LIST_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            error: payload,
            fetchStatus:false,
        });
    },

    //考点树
    [ActionTypes.GET_TREEDATE_KNOW_LIST_REQUEST]: (state,payload) => {
        return Object.assign({}, state, {
            fetchStatus: true,
        });
    },
    [ActionTypes.GET_TREEDATE_KNOW_LIST_SUCCESS]: (state,payload) => {
        return Object.assign({}, state, {
            issueTree:payload,
            fetchStatus:false,
        });
    },
    [ActionTypes.GET_TREEDATE_KNOW_LIST_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            error: payload,
            fetchStatus:false,
        });
    },


    [ActionTypes.SET_PROPS_EDITION_CURRENT]: (state, payload) => {
        return Object.assign({}, state, {
            editionCurrent: payload,
        });
    },
    [ActionTypes.SET_PROPS_BOOK_CURRENT]: (state, payload) => {
        return Object.assign({}, state, {
            bookCurrent: payload,
        });
    },
    [ActionTypes.SET_PROPS_ASSIST_CURRENT]: (state, payload) => {
        return Object.assign({}, state, {
            assistCurrent: payload.data,
            assist:payload.assist
        });
    },
    //
    [ActionTypes.HANDLE_EDITION]: (state, payload) => {
        return Object.assign({}, state, {
            handleEdition: payload,
        });
    },
    [ActionTypes.HANDLE_ASSIST]: (state, payload) => {
        return Object.assign({}, state, {
            handleAssist: payload,
        });
    },
    [ActionTypes.HANDLE_BOOK]: (state, payload) => {
        return Object.assign({}, state, {
            handleBook: payload,
        });
    },

    //版本列表
    [ActionTypes.GET_EDITION_LIST_REQUEST]: (state,payload) => {
        return Object.assign({}, state, {
            fetchStatus: true,
        });
    },
    [ActionTypes.GET_EDITION_LIST_SUCCESS]: (state,payload) => {
        return Object.assign({}, state, {
            editionList:payload.list,
            fetchStatus:false,
        });
    },
    [ActionTypes.GET_EDITION_LIST_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            error: payload,
            fetchStatus:false,
        });
    },

    //课本列表
    [ActionTypes.GET_BOOK_LIST_REQUEST]: (state,payload) => {
        return Object.assign({}, state, {
            fetchStatus: true,
        });
    },
    [ActionTypes.GET_BOOK_LIST_SUCCESS]: (state,payload) => {
        return Object.assign({}, state, {
            bookList:payload.list,
            fetchStatus:false,
        });
    },
    [ActionTypes.GET_BOOK_LIST_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            error: payload,
            fetchStatus:false,
        });
    },

    //教辅列表
    [ActionTypes.GET_ASSIST_LIST_REQUEST]: (state,payload) => {
        return Object.assign({}, state, {
            fetchStatus: true,
        });
    },
    [ActionTypes.GET_ASSIST_LIST_SUCCESS]: (state,payload) => {
        return Object.assign({}, state, {
            assistList:payload.list,
            fetchStatus:false,
        });
    },
    [ActionTypes.GET_ASSIST_LIST_FAILURE]: (state, payload) => {
        return Object.assign({}, state, {
            error: payload,
            fetchStatus:false,
        });
    },

    //设置版本列表
    [ActionTypes.SET_PROPS_EDITION_LIST]: (state,payload) => {
        return Object.assign({}, state, {
            editionList:payload,
        });
    },
    //设置课本列表
    [ActionTypes.SET_PROPS_BOOK_LIST]: (state,payload) => {
        return Object.assign({}, state, {
            bookList:payload,
        });
    },
    //设置教辅列表
    [ActionTypes.SET_PROPS_ASSIST_LIST]: (state,payload) => {
        return Object.assign({}, state, {
            assistList:payload,
        });
    },



}
export const INITIALIZE_STATE = {
    filterList:[],
    filterAssist:[],
    issueTree:[],
    knowTree:[],

    editionList:[],
    editionCurrent:'',

    bookList:[],
    bookCurrent:'',

    assistList:[],
    assistCurrent:'',
    assist:{},
    
    handleEdition:'',
    handleAssist:'',
    handleBook:''

}
const reducer = (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};
export default reducer


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/reducer.js